import CTA from "@/components/common/CTA";
import Srcset from "@/components/common/Srcset";
import styles from "../PortraitTile/PortraitTile.module.scss";
import { navigationTracking } from "@/components/common/Tracking";

const PortraitTile = (props) => {
  const navigationTitle = props?.navigationTitle;
  props = props?.props;
  return (
    <>
      <a className={`portrait-header ${styles.portrait_wrapper} ${props.hideOnMobile ? "hide-tab-mob" : ""}`} {...props.CTAUrl ? { href: props.CTAUrl } : {}}
        // onClick={() => props.CTAText && navigationTracking("Navigation link: " + navigationTitle + " > " + props.CTAText)}
        data-ga4={"Navigation link: " + navigationTitle + " > " + props.CTAText}>
        <Srcset
          svgFile={true}
          src={props.image}
          requirePath={false}
          alt={props.imageAltText? props.imageAltText : props.header}
          className={`type_image ${styles.type_image}`}
        />
        <div className={`${styles.text_box} ${props.lightText?"light-text":""} ${props.squareTile?"":styles.version_1}`}>
          <div className={`italic large-md small-sm small-xs ${styles.header}`}>{props.header}</div>
          <div className={styles.cta_wrapper}>
            <CTA text={props.CTAText} link={props.CTAUrl} lightText={props.lightText}  sizeClass="bordered x-small-xs x-small-sm normal-md" />
          </div>
        </div>
      </a>
    </>
  );
};
export default PortraitTile;
